module.exports = __webpack_public_path__ + "static/ISO-14001-0000d1f8c00f09ea1b4ba8bce9b8906f.png";